import { kanaToRomaji } from "./kanaToRomaji";

// kanaToRomaji transliterates kana one by one, so は always comes out as "ha"
// and へ as "he". Hepburn writes the particles as they sound (は = "wa",
// へ = "e"), and a few fixed expressions keep that sound: こんにちは is
// "konnichiwa", never "konnichiha". Every other は in the JLPT lists is a real
// "ha" (歯, 母, 爆破), which is why the plain conversion is the default.
//
// Keyed by reading, so the entry is found whichever way the word is written
// (又は / または, 或いは / あるいは). The data guard in vocabularyRomaji.test.ts
// fails if a rebuilt word list adds a reading of this shape that is neither
// listed here nor reviewed as a genuine "ha".
const EXPRESSION_ROMAJI_BY_READING = new Map([
    ["こんにちは", "konnichiwa"],
    ["こんばんは", "konbanwa"],
    ["それでは", "sorewa"],
    ["では", "dewa"],
    ["または", "matawa"],
    ["あるいは", "aruiwa"],
    ["じつは", "jitsuwa"],
    ["もしくは", "moshikuwa"],
    ["ひいては", "hiitewa"],
]);

// The particles are entries of their own (word と reading both は). A noun read
// は, such as 歯 or 葉, has a different word and stays "ha".
const PARTICLE_ROMAJI = new Map([
    ["は", "wa"],
    ["へ", "e"],
]);

export function vocabularyRomaji(word: string, reading: string): string {
    const expression = EXPRESSION_ROMAJI_BY_READING.get(reading);
    if (expression) return expression;
    if (word === reading) {
        const particle = PARTICLE_ROMAJI.get(reading);
        if (particle) return particle;
    }
    return kanaToRomaji(reading);
}
